import React from "react";
import ExternalArrow from "../external-arrow";
import { BookCallLink } from "./style";

const CALENDLY_URL = "https://calendly.com/freddy11sanjaya/one-on-one-w-freddy";

const BookCall = () => (
  <BookCallLink
    href={CALENDLY_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Book a one-on-one call with Freddy on Calendly"
  >
    Book a call here <ExternalArrow />
  </BookCallLink>
);

export default BookCall;
